module.exports = __webpack_public_path__ + "img/landing.207b9f17.jpeg";